import { getErrorss } from '../../../../functions/errors/GetErrors'
import { beginKeyOperation, runKeyOperation, finishKeyOperation } from '../../keyViewings/keyHandover'
import { ACCESS_KEY, urlAPI } from '../../../../urls'
import { dataFetchingFinish, dataFetchingStart } from '../../../../store/slices/modalSlice'
import { addViewing, viewingsFetchingError } from '../../../../store/slices/viewingsSlice'
import { type AppDispatch } from '../../../../store/store'
import { fetchViewings, viewingsQuery } from '../../../../store/actionsCreators/viewingsActions'
import { buildManualViewingPayload } from './manualViewingPayload'
import { createManualViewingUserNotifications } from './manualViewingNotifications'
import { type ManualViewingFormValues, type ManualViewingSubmitResult } from './manualOperations.types'

export const createManualViewing = (values: ManualViewingFormValues) => async (dispatch: AppDispatch): Promise<ManualViewingSubmitResult> => {
    const jwt = window.localStorage.getItem(ACCESS_KEY)
    const bodyObject = {
        method: 'POST',
        collection: 'viewings',
        query: viewingsQuery,
        body: buildManualViewingPayload(values)
    }

    try {
        dispatch(dataFetchingStart())
        if (values.receivedKey != null) {
            const key = values.receivedKey
            if (!values.unit.accessStatuses.includes('Keys in BSO office') || key.holder.id !== values.userId) throw new Error('Select the actual key holder for this viewing.')
            const operation = beginKeyOperation({ kind: 'received', admin: key.admin, recipient: key.holder, unitId: bodyObject.body.Unit, pickup: key.pickup, returnAt: key.returnAt, note: values.complaint ?? '', viewing: { ...bodyObject.body, Statuses: ['Approved'] } })
            await runKeyOperation(operation)
            if (operation.viewingId == null) throw new Error('Unable to identify the created key viewing.')
            // Key handover always creates an active Approved viewing, even when
            // the form initially showed the historical Completed default.
            await createManualViewingUserNotifications({ ...values, status: 'Approved' }, operation.viewingId)
            await dispatch(fetchViewings({ noLading: true }))
            window.dispatchEvent(new Event('bso:key-viewings-changed'))
            finishKeyOperation(operation.id)
            dispatch(dataFetchingFinish())
            return { isSuccessful: true }
        }
        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            },
            body: JSON.stringify(bodyObject)
        })
        const dataJSON = await response.json()

        if (dataJSON.success === true && dataJSON.response?.error == null) {
            dispatch(addViewing(dataJSON.response.data))
            await createManualViewingUserNotifications(values, dataJSON.response.data.id)
            await dispatch(fetchViewings({ noLading: true }))
            dispatch(dataFetchingFinish())
            return { isSuccessful: true }
        }

        const error = getErrorss(dataJSON)
        dispatch(viewingsFetchingError(error))
        dispatch(dataFetchingFinish())
        return { isSuccessful: false, error }
    } catch (error) {
        const message = error instanceof Error ? error.message : 'Could not create viewing.'
        dispatch(viewingsFetchingError(message))
        dispatch(dataFetchingFinish())
        return { isSuccessful: false, error: message }
    }
}
